import { useTranslation } from "react-i18next"
import { Banner } from "@/components/ui/banner"
import { BetterDocButton } from "@/modules/patients/detail/better-doc/components/better-doc-button"
import { BetterDocUsageFailureDialog } from "@/modules/patients/detail/better-doc/components/better-doc-usage-failure-dialog"
import type { ApplicableBetterDocUsage } from "@/modules/patients/detail/better-doc/hooks/useApplicableBetterDocUsage"
import { isBetterDocRequired } from "@/modules/patients/detail/better-doc/lib/is-better-doc-required"
import { EpisodeOfCareProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"

type BetterDocSectionProps = {
  applicableBetterDocUsage: ApplicableBetterDocUsage
  episodeOfCareProgressNoteData: EpisodeOfCareProgressNoteData | undefined
}

export const BetterDocSection = ({
  applicableBetterDocUsage,
  episodeOfCareProgressNoteData,
}: BetterDocSectionProps) => {
  const { t } = useTranslation()
  const { betterDocUsage, shouldShowBetterDocUsageFailure, dismissBetterDocUsageFailure } = applicableBetterDocUsage
  const isBetterDocShown =
    betterDocUsage === "ALLOWED" || betterDocUsage === "REQUIRED" || betterDocUsage === "CONDITION_PACKAGE"

  return (
    <>
      {isBetterDocShown && (
        <div className="mt-4 flex items-center gap-2">
          {(betterDocUsage === "ALLOWED" || betterDocUsage === "CONDITION_PACKAGE") && (
            <Banner type="inline" variant="warning" data-testid="better-doc-allowed-banner">
              {t("episodeOfCare.progressNote.pointOfCare.betterDocAllowed")}
            </Banner>
          )}

          {isBetterDocRequired(betterDocUsage) && (
            <Banner type="inline" variant="critical" data-testid="better-doc-required-banner">
              {t("episodeOfCare.progressNote.pointOfCare.betterDocRequired")}
            </Banner>
          )}

          <BetterDocButton episodeOfCareProgressNoteData={episodeOfCareProgressNoteData} />
        </div>
      )}
      <BetterDocUsageFailureDialog open={shouldShowBetterDocUsageFailure} onClose={dismissBetterDocUsageFailure} />
    </>
  )
}
